/**
 * FolderIcon - Icon representing a folder/directory
 * Line-based folder shape
 */

import type { IconProps } from './IconTypes';

export function FolderIcon({
  size = 20,
  className = '',
  'aria-label': ariaLabel = 'Folder',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-label={ariaLabel}
      role="img"
    >
      {/* Folder shape with tab */}
      <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
    </svg>
  );
}
